import React from "react";

import { GoogleOutlined } from "@ant-design/icons";

import firebase from "firebase/app";

import { auth } from "../firebase";
import { Link } from "react-router-dom";

export default function Login() {
  return (
    <div id="login-page">
      <div id="login-card">
        <h2>Welcome to Acacias Forum!</h2>

        <div
          className="login-button google"
          onClick={() =>
            auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())
          }
        >
          <GoogleOutlined /> Access the Forum With your Google Account
        </div>
      </div>
      <div id="footer">
        <Link id="links" target="_blank">
          {/* <h1>Developed by an Alumni:</h1> */}
          <a href="https://allahurodrigues.netlify.app/">
            {" "}
            Developed by an Alumni: <span>Allahu Rodrigues!</span>
          </a>
        </Link>
      </div>
    </div>
  );
}
